import { z } from 'zod';

/** Exactly 10 digits (Indian phone number length). */
export const phoneSchema = z.object({
  phone: z
    .string()
    .min(1, 'Phone number is required')
    .regex(/^\d{10}$/, 'Please enter a valid 10-digit phone number'),
});

export type PhoneValues = z.infer<typeof phoneSchema>;

export const loginWithPasswordSchema = z.object({
  password: z.string().min(1, 'Password is required'),
});

export type LoginWithPasswordValues = z.infer<typeof loginWithPasswordSchema>;

export const setNewPasswordSchema = z
  .object({
    password: z.string().min(1, 'Password is required'),
    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export type SetNewPasswordValues = z.infer<typeof setNewPasswordSchema>;
